import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../environments/environment";
import {HomeyConfigDto, UpdateHomeyConfigCommand} from "admin-api-dto";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor(private readonly http: HttpClient) {
  }

  getConfig(): Observable<HomeyConfigDto> {
    return this.http.get<HomeyConfigDto>(`${environment.apiUrl}/api/private/config`);
  }

  updateConfig(command: UpdateHomeyConfigCommand): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/api/private/config`, command);
  }
}
